var _path, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrownLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 27,
    viewBox: "0 0 46 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9509 10.487C34.691 10.6866 34.3247 10.6682 34.0861 10.4435L23.4579 0.431387C23.2007 0.189086 22.7993 0.189086 22.5421 0.431387L11.9139 10.4435C11.6753 10.6682 11.309 10.6866 11.0491 10.487L1.23366 2.94759C0.76833 2.59017 0.101307 2.96352 0.162662 3.54706L2.5657 26.402C2.60144 26.7419 2.88807 27 3.22987 27H42.7701C43.1119 27 43.3986 26.7419 43.4343 26.402L45.8373 3.54706C45.8987 2.96352 45.2317 2.59017 44.7663 2.94759L34.9509 10.487Z",
    fill: "url(#paint0_linear_3_10)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 46,
    height: 3,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_10",
    x1: -1.41538,
    y1: 3.98572,
    x2: 54.7659,
    y2: 9.90009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#592EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609084,
    stopColor: "#592EE5",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#592EE5",
    stopOpacity: 0.75
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownLogo);
export default __webpack_public_path__ + "static/media/crown_logo.cf2b03795d38b722416b92f7fee3d59d.svg";
export { ForwardRef as ReactComponent };